
import React from 'react';
import AudioPlayer from './AudioPlayer';
import { useLanguage } from '@/context/LanguageContext';
import { AudioTrack } from '@/data/types';

interface ExhibitAudioProps {
  track: AudioTrack;
  language: string;
}

const ExhibitAudio = ({ track, language }: ExhibitAudioProps) => {
  const { t } = useLanguage();

  return (
    <div className="mb-4">
      <AudioPlayer 
        language={language}
        t={t}
        audioUrl={track.url}
        track={track}
      />
    </div>
  );
};

export default ExhibitAudio;
